module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABPUlEQVQ4T42TT07CQBTGvzeExp10wdCd3kA4gXIDbmBdGjDgSayx1aX1Bt5APIH1BLIcigllR2roM7R2+FvprCaZ933fm9+8IRSs6V2tFhtHH0Y8b5m3UbSvjIrEoddwAOqD8SJ7yi4tnj5Zpz8JvlaCRUt2J8G2wd7k0LV8EC51MWMoe6r9rzhNXOAcBH+nTYZdreDdvFaj/Iy+H2UnSUQf4CaIakUMVl1wBFAgRHJPodsIQHR2ULRdwPxJGRwOADoub8CzqqBmCiz06k1ADMsbZPQ17dCzlm/5XCL9SnZVCnTjqcauNSLCSaEBcyR7Y1PTXi8MPYsPJcuu0oF6sztVRTaradPiyYN1wQJvmYRnDHIMAT9OYBN4kMOkBO36jRpu3HlJnLnyupwuI5476z/p74cNwLCJFp18zn8B/rl8Gzq9kqMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fullstar.png
// module id = cGqB
// module chunks = 1